export default __webpack_public_path__ + "0a62760ce38dbc5e2cbb0ef0b879ebca.png";